import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Logger } from '@app/@shared';
import { BlackUser } from '@app/@shared/models/customer.model';
import { AuthService } from '@app/@shared/services/auth.service';
import { CustomerService } from '@app/@shared/services/customer.service';
import { AlertController, IonInput, LoadingController, ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

const log = new Logger('recovery-component');

@Component({
  selector: 'app-recovery',
  templateUrl: './recovery.component.html',
  styleUrl: './recovery.component.scss',
})
export class RecoveryComponent {
  @ViewChild('inputEmail') inputEmail!: IonInput;
  @Input() status = '';
  email = '';

  form!: FormGroup;
  blackUser: BlackUser[] = [];

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private authS: AuthService,
    private fb: FormBuilder,
    private loadingCtrl: LoadingController,
    private translateS: TranslateService,
    private customerS: CustomerService
  ) {}

  ngOnInit() {
    this.customerS.getBlackUsers().then((blackUsers) => {
      this.blackUser = blackUsers || [];
    });
  }

  ionViewDidEnter() {
    log.info(this.email);
    this.createForm();
    setTimeout(() => {
      this.inputEmail.setFocus();
    }, 800);
  }

  createForm() {
    this.form = this.fb.group({
      email: [this.email ?? '', [Validators.required, Validators.email]],
    });
  }

  close() {
    this.modalCtrl.dismiss(null, 'close');
  }

  async onSubmit() {
    const loading = await this.loadingCtrl.create({
      message: this.translateS.instant('loading'),
    });
    await loading.present();

    const { email } = this.form.value;

    // Si el status es 'migrate', usar setPasswordClaim en lugar de sendRestorePasswordMail
    let response: boolean;
    if (this.status === 'migrate') {
      response = await this.authS.setPasswordClaim(email);
    } else {
      response = await this.authS.sendRestorePasswordMail(email);
    }

    if (response) {
      const alert = await this.alertCtrl.create({
        header: 'Correo enviado correctamente',
        message:
          this.status === 'migrate'
            ? 'Te enviamos un correo para establecer tu contraseña. No olvides revisar tu bandeja de SPAM. ¡Te esperamos!'
            : 'No olvides revisar tu bandeja de SPAM. ¡Te esperamos!',
        buttons: ['Ok'],
      });

      await loading.dismiss();
      await alert.present();
      this.close();
    } else {
      const toast = await this.toastCtrl.create({
        message: 'Ocurrió un error al enviar email, favor de reintentar',
        duration: 3000,
        buttons: [
          {
            icon: 'close',
          },
        ],
        color: 'danger',
      });

      await loading.dismiss();
      await toast.present();
    }
  }
}
